import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GetByGuidService } from '../../../templates/services/get-by-guid-service.template';
import { Core2Config } from '../../../utils/core2-config';
import { ApiVisa } from '../../../models/base/apivisa.model';
import { PagingResponseModel } from '../../../models/base/paging-response.model';
import { CMSWebsiteContainerModel, CMSWebsiteCountriesContainerModel } from '../../../models/cms/cms-website-container.model';
import { getHttpHeader } from '../../../utils/http-header.factory';

@Injectable({
  providedIn: 'root'
})
export class CMSWebsiteService extends GetByGuidService<CMSWebsiteContainerModel> {

  constructor(protected readonly h: HttpClient) {
    super(Core2Config.TENANT_DOMAIN_URL_PREFIX + 'cms/websites', h);
  }

  public getRegions(website_hdr_guid: string, { tenantCode, api_domain_url, jwt_secret }: ApiVisa): Observable<PagingResponseModel<CMSWebsiteCountriesContainerModel>>{
    return this.http.get<PagingResponseModel<CMSWebsiteCountriesContainerModel>>(`${ api_domain_url }${ this.apiUrl }-countries/${ website_hdr_guid }`, getHttpHeader(jwt_secret, tenantCode));
  }
}
